import React from 'react';
import pluralize from 'pluralize';

import css from './InactiveEmailAlert.module.css';
import { Alert, AlertPropsType, Button } from '@mm/components';
import { BotBuilderRoutes } from '../../../routes/bot-builder-routes';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';

export const InactiveEmailAlert = (
  props: AlertPropsType & { plural?: boolean },
) => {
  const history = useHistory();
  const chatbotId = useSelector(activeChatbotIdSelector);

  return (
    <Alert
      className={css.container}
      borderRadius={0}
      showCloseIcon={false}
      type="warning"
      showHeader
      {...props}
    >
      <div>
        <span className={css.title}>
          Action Required: Reconnect Your{' '}
          {pluralize('Email', props.plural ? 2 : 1)}
        </span>
        <span className={css.subtitle}>
          To continue sending emails, please reconnect your email in your
          account settings
        </span>

        <Button
          onClick={e => {
            e?.preventDefault();
            history.push(BotBuilderRoutes.integrations.getLink({ chatbotId }), {
              options: 'gmail',
            });
          }}
        >
          Fix {pluralize('Email', props.plural ? 2 : 1)}
        </Button>
      </div>
    </Alert>
  );
};
